var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5778 16.8155C16.908 16.7467 17.1054 16.4009 16.9409 16.1054C16.5783 15.4551 16.0076 14.8832 15.2778 14.4477C14.3373 13.8865 13.1845 13.582 12 13.582C10.8155 13.582 9.66267 13.8859 8.72223 14.4477C7.99237 14.8832 7.42165 15.4551 7.05912 16.1054C6.8946 16.4009 7.09202 16.7467 7.42225 16.8155C10.4414 17.4448 13.558 17.4448 16.5772 16.8155",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 12.9824C13.651 12.9824 14.9902 11.6432 14.9902 9.99121C14.9902 8.33921 13.651 7 11.999 7C10.347 7 9.00781 8.33921 9.00781 9.99121C9.00781 11.6432 10.347 12.9824 11.999 12.9824Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile3.a405798597176d97a10d3e2f31739c82.svg";
export { ForwardRef as ReactComponent };